import React, { PureComponent } from 'react';
import style from './styles/style.module.css';

import iconFile from 'appSrc/assets/icons/custom/forms.svg';

export default class FormIcon extends PureComponent {
    render() {
        var inlineStyles = { ...this.props.style };
        if( this.props.size ) {
            inlineStyles.height = 'auto';
            inlineStyles.width = this.props.size + 'px';
        }
        return (
            <div className={ `${ this.props.className } ${ style.icon }` } style={ inlineStyles }>
                <img src={ iconFile } alt={ this.props.label }/>
            </div>
        );
    }
}
FormIcon.defaultProps = {
    className: '',
    label: 'completed form icon',
};
